import { render, staticRenderFns } from "./myBookingRegionPage.vue?vue&type=template&id=62ad5f09&scoped=true&"
import script from "./myBookingRegionPage.vue?vue&type=script&lang=js&"
export * from "./myBookingRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./myBookingRegionPage.vue?vue&type=style&index=0&id=62ad5f09&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad5f09",
  null
  
)

export default component.exports